import styled, { css } from 'styled-components';

import ImageSlider from '~/src/common/components/ImageSlider/ImageSlider';
import { COLORS } from '~/src/common/theme';
import { media } from '~/src/common/theme/styles-constants';
import { ProductPriceAndPick } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/components/ProductPriceAndPick/ProductPriceAndPick';
import { ProductPrimaryInformation } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/components/ProductPrimaryInformation/ProductPrimaryInformation';
import { ProductSecondaryInformation } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/components/ProductSecondaryInformation/ProductSecondaryInformation';
import { ProductShortDescription } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/components/ProductShortDescription/ProductShortDescription';
import { ProductGridArea } from '~/src/screens/CatalogContent/ContentScreen/ProductScreen/constants';

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-top: 16px;
  padding-bottom: 56px;
  margin: 0 5px;
  max-width: 1200px;

  ${media.M`
    gap: 8px;
    margin: auto;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 24px;

  grid-template-areas:
    '${ProductGridArea.PrimaryInfos}'
    '${ProductGridArea.Gallery}'
    '${ProductGridArea.SecondaryInfos}'
    '${ProductGridArea.ShortDescription}';

  ${media.M`
    grid-template-columns: 1fr 450px;
    grid-row-gap: 16px;
    grid-column-gap: 40px;

    grid-template-areas: 
    "${ProductGridArea.Gallery} ${ProductGridArea.PrimaryInfos}"
    "${ProductGridArea.Gallery} ${ProductGridArea.Picker}"
    "${ProductGridArea.Gallery} ${ProductGridArea.SecondaryInfos}"
    "${ProductGridArea.Gallery} ${ProductGridArea.ShortDescription}"
  `}
`;

export const AsideBlock = css`
  ${media.M`
    padding-top: 16px;
    border-top: 1px solid ${COLORS.NEUTRAL_STROKE};
  `}
`;

export const PrimaryInformation = styled(ProductPrimaryInformation)`
  grid-area: ${ProductGridArea.PrimaryInfos};
`;

export const ProductImageSlider = styled(ImageSlider)`
  grid-area: ${ProductGridArea.Gallery};
  overflow: hidden;

  && {
    --ratio: 1 / 1;
  }
`;

export const Picker = styled(ProductPriceAndPick)`
  grid-area: ${ProductGridArea.Picker};
  ${AsideBlock}

  ${media.M`
    padding: 16px 0 0;
  `}
`;

export const SecondaryInformation = styled(ProductSecondaryInformation)`
  grid-area: ${ProductGridArea.SecondaryInfos};
  ${AsideBlock}
`;

export const ShortDescription = styled(ProductShortDescription)`
  grid-area: ${ProductGridArea.ShortDescription};
  ${AsideBlock}
`;
